<template>
  <div class="highlight-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${highlightId ? 'Editar' : 'Cadastrar'}`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'store-highlights.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <highlight-form
        @submit="onSubmit"
        :id="highlightId"
        :errors="errors"
        :saving="isSaving"
      ></highlight-form>
    </app-card>
  </div>
</template>

<script>
import HighlightForm from '@/components/Forms/StoreHighlightForm.vue';
import HighlightService from '@/services/store-highlights.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'highlight-form-page',
  mixins: [ToastMixin],
  components: {
    HighlightForm,
  },
  data: () => {
    return {
      highlightId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.highlightId && this.save(data);
      this.highlightId && this.update(this.highlightId, data);
    },
    save(data) {
      this.isSaving = true;
      HighlightService.save(data)
        .then(() => {
          this.toastify('Campanha cadastrada com sucesso!');
          this.$router.push({ name: 'store-highlights.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Campanha',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      HighlightService.update(id, data)
        .then(() => {
          this.toastify('Campanha atualizada com sucesso!');
          this.$router.push({ name: 'store-highlights.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Campanha',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.highlightId = this.$route.params.id;
  },
};
</script>
